import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import defaultLogo from 'assets/img/illustrations/y4.png';
import { useTranslation } from 'react-i18next';
import { getConfigImageUrl } from 'y4/Falcon';

const Logo = ({ at, width, className, textClass, ...rest }) => {
  const { t } = useTranslation();

  //Load logo from back end
  const [logo, setLogo] = useState(defaultLogo);

  useEffect(() => {
    getConfigImageUrl('MainIcon').then(url => {
      if (url) setLogo(url);
    });
  }, []);
  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="me-2" src={logo} alt="Y4" width={width} />
        <span className={classNames('font-sans-serif', textClass)}>
          {t('System name')}
        </span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
